'use client'
import ImageHandler from '@/components/imageHandler';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useAddPictureToGallery } from '@/lib/hooks/admin-dashboard/gallery/post/useAddPictureToGallery';
import React, { useState } from 'react'
import toast from 'react-hot-toast';

const GalleryHeader = () => {
    const [title, setTitle] = useState<string>('');
    const [imageUrls, setImageUrls] = useState<string[]>([]);
    const {mutate: uploadImageToGallery} = useAddPictureToGallery();
    const handleUploadImageToGallery = () => {
        if(!title || !imageUrls[0]) {
            toast.error("Please enter title and select image")
            return;
        };
        uploadImageToGallery({ name: title, imageUrl: imageUrls[0] });
        setTitle('');
        setImageUrls([]);
        toast.success("Image uploaded successfully")
    };
    return (
        <header className='flex gap-10 justify-between'>
            <section>
                <h1 className='text-4xl'>Gallery Management</h1>
            </section>
            <section className='flex'>
                <Input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Title"
                    className="border p-2 rounded-lg"
                />
                <ImageHandler
                    imageUrls={imageUrls}
                    setImageUrls={setImageUrls}
                    multiple={false}
                    inputId="upload"
                />
                <Button className="ml-10" onClick={handleUploadImageToGallery}>Upload</Button>
            </section>
        </header>
    )
}

export default GalleryHeader